import { Form } from './form';
import { FormTypes } from './form-types';
import { Config } from '../config';
import { MultipleContactsView } from '../view/multiple-contacts-view';
import { MultipleContactsValidator } from '../validators/multiple-contacts-validator';
import { Order } from '../config/order';

export class LogFailingOnInitForm extends Form {

    view: MultipleContactsView = new MultipleContactsView();
    type = FormTypes.LogFailingOnInit;
    fields = [];
    fieldGroup: Node[][] = [];
    validator: MultipleContactsValidator = new MultipleContactsValidator();


    async init(config: Config, callbacks: any) {
        await super.init(config, callbacks);

        return Promise.reject(new Error('Js Logging - Error on Init.'));
    }

    async render() {
        this.view.init();
    }

    renderContact() {

    }

    public submit(order: Order) {

        return Promise.resolve(order);
    }

    validate() {
        return Promise.resolve(true);
    }


}
